import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [
    {
        path: '/',meta:{title:'合肥高创股份有限公司'},
        component: resolve => require(['../components/Index.vue'], resolve)
    },
    {
        path: '/newsList',meta:{title:'合肥高创股份有限公司'},
        component:resolve => require(['../components/newsList.vue'],resolve)
    },
    {
        path:'/newsDetail',meta:{title:'合肥高创股份有限公司'},
        component:resolve => require(['../components/newsDetail'],resolve)
    },
    {
        path:'/policyList',meta:{title:'合肥高创股份有限公司'},
        component:resolve => require(['../components/policyList'],resolve)
    },
    {
        path:'/policyDetail',name:'policyDetail',meta:{title:'合肥高创股份有限公司'},
        component:resolve => require(['../components/policyDetail'],resolve)
    },
    {
        path:'/about',name:'about',meta:{title:'关于高创'},
        component:resolve => require(['../components/about'],resolve)
    },
    {
        path:'/update',name:'update',meta:{title:'网站升级中'},
        component:resolve => require(['../components/update'],resolve)
    },
    {
        path:'/tip',name:'tip',meta:{title:'浏览器版本过低,请先升级!'},
        component:resolve => require(['../components/tip'],resolve)
    },
    {
        path:'/searchList',name:'searchList',meta:{title:'合肥高创股份有限公司'},
        component:resolve => require(['../components/searchList'],resolve)
    },
    {
        path:'/park',name:'park',meta:{title:'园区企业'},
        component:resolve => require(['../components/park'],resolve)
    },
    {
        path:'/wisdow',name:'wisdow',meta:{title:'智慧高创'},
        redirect:'/wisdowList',
        component:resolve => require(['../components/wisdow.vue'],resolve),
        children:[
            {
                path:'/wisdowList',name:'wisdowList',meta:{title:'智慧高创-课程培训'},
                component:resolve => require(['../components/wisdowList'],resolve),
            },
        ]
    },
    {
        path:'/grow',name:'grow',meta:{title:'智慧高创'},redirect:'/growPlus',
        component:resolve=>require(['../components/grow'],resolve),
        children:[
            {
                path:'/growPlus',name:'growPlus',meta:{title:'智慧高创-成长+-课程培训'},
                component:resolve=>require(['../components/growPlus'],resolve),
            },
            {
                path:'/schedule',name:'schedule',meta:{title:'智慧高创-成长+-课程表'},
                component:resolve=>require(['../components/schedule'],resolve),
            },
            {
                path:'/growIntro',name:'growIntro',meta:{title:'智慧高创-成长+ 介绍'},
                component:resolve=>require(['../components/growIntro'],resolve),
            },
            {
                path:'/wisdowDetail',name:'wisdowDetail',meta:{title:'智慧高创-课程培训'},
                component:resolve=>require(['../components/wisdowDetail'],resolve),
            },
        ]
    },
    {
        path:'/plat',name:'plat',meta:{title:'智慧高创'},redirect:'/platform',
        component:resolve=>require(['../components/plat'],resolve),
        children:[
            {
                path:'/platform',name:'platform',meta:{title:'智慧高创-平台+'},
                component:resolve=>require(['../components/platform'],resolve),
            },
        ]
    },
    {
        path:'/finan',name:'finan',meta:{title:'智慧高创'},redirect:'/financial',
        component:resolve=>require(['../components/finan'],resolve),
        children:[
            {
                path:'/financial',name:'financial',meta:{title:'智慧高创-金服+'},
                component:resolve=>require(['../components/financial'],resolve),
            }
        ]
    },
    {
        path:'/partyIndex',name:'partyIndex',meta:{title:'合肥高创党建网'},
        component:resolve=>require(['../components/party/partyIndex'],resolve),
    },
    {
        path:'/articleList',name:'articleList',meta:{title:'合肥高创党建网-文章列表'},
        component:resolve=>require(['../components/party/articleList'],resolve),
    },
    {
        path:'/articleDetail',name:'articleDetail',meta:{title:'合肥高创党建网-文章详情'},
        component:resolve=>require(['../components/party/articleDetail'],resolve),
    },
    {
        path:'/introduce',name:'introduce',meta:{title:'合肥高创党建网-党委介绍'},
        component:resolve=>require(['../components/party/introduce'],resolve),
    },
    {
        path:'/medium',name:'medium',meta:{title:'载体+'},
        component:resolve=>require(['../components/medium'],resolve),
    },
    {
        path:'/wisdowPlus',name:'wisdowPlus',meta:{title:'智慧+'},
        component:resolve=>require(['../components/wisdowPlus'],resolve),
    },
    {
        path:'/companyInfo',name:'companyInfo',meta:{title:'智慧高创-金服+'},  //服务联盟详情页
        component:resolve=>require(['../components/companyInfo'],resolve),
    }
  ]
})

router.beforeEach((to, from, next) => {
	window.document.title = to.meta.title;
    next();
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js